import { useEffect, useRef, useState } from "react"
import { useParams } from "react-router-dom"
import { Container } from "../../styles/policy"

export default function PolicyPage() {

  const frameRef = useRef<HTMLIFrameElement>(null)

  let {type} = useParams()

  const [link, setLink] = useState('')
  const [height, setHeight] = useState(0)

  useEffect(() => {

    if(type === 'service') {
      setLink('../service1.html')
    }
    else if(type === 'privacy') {
      setLink('../privacy.html')
    }
    else if(type === 'immunity') {
      setLink('../immunity.html')
    }

  }, [type])
  
  useEffect(() => {
    if(link === '' || !frameRef.current) return

    const body = frameRef.current.contentWindow?.document.body
  }, [link, frameRef])

  return (
    <Container>
       <iframe
          ref={frameRef}
          src={link}
          height={height}
          onLoad={(event) => {
            const { contentWindow } = event.currentTarget
            if(!contentWindow) return
            const body = contentWindow?.document.body
            setHeight(body.scrollHeight)
          }}
        />
    </Container>
  )
}